<template>
  <div>
    <h2>Add Program</h2>
    <div class="description">Add program of school / college</div>

    <v-form direction="horizontal" :model="form" :rules="rules" ref="formRef">

      <div class="form-elem-wrap">
        <div style="width:100%">
          <v-form-item label="Program Name" :label-col="{span: 6}" :wrapper-col="{span: 14}" prop="name">
            <v-input size="large" v-model="form.name" placeholder="Program Name"></v-input>
          </v-form-item>

          <v-form-item label="Level of Study" :label-col="{span: 6}" :wrapper-col="{span: 14}"
            prop="level_of_study">
            <v-select placeholder="Level of Study" size="large" v-model="form.level_of_study"
              :data="optionsStudyLevels" @change="(value) => selectChange('level_of_study', value)"></v-select>
          </v-form-item>

          <v-form-item label="Duration" :label-col="{span: 6}" :wrapper-col="{span: 14}" prop="duration">
            <v-input size="large" v-model="form.duration" placeholder="Duration"></v-input>
          </v-form-item>

          <v-form-item label="Application Fee" :label-col="{span: 6}" :wrapper-col="{span: 14}" prop="application_fee_val">
            <v-input size="large" v-model="form.application_fee_val" placeholder="Application Fee"></v-input>
          </v-form-item>

        </div>

        <div style="width:100%">
          <v-form-item label="School / College Name" :label-col="{span: 6}" :wrapper-col="{span: 14}" prop="school_name">
            <v-select placeholder="School / College Name" size="large" v-model="form.school_name"
              :data="schools.map(x => ({label: `${x.campus ? x.name + ', ' + x.campus : x.name}`, value: `${x.campus ? x.name + ', ' + x.campus : x.name}`}))"
              @change="selectSchool" v-if="schools"></v-select>
          </v-form-item>

          <v-form-item label="Area of Study" :label-col="{span: 6}" :wrapper-col="{span: 14}" prop="area_of_study" style="position:relative">
            <v-input size="large" v-model="form.area_of_study" placeholder="Area of Study"
              @keyup="studyOptionsDisplay=true"></v-input>
            <ul class="typeahead-list" v-if="form.area_of_study && studyOptionsDisplay && studyOptionsText.indexOf(form.area_of_study.toLowerCase()) > -1">
              <li v-for="study_area in optionsStudyAreas" :key="study_area.label" class="study-area-option"
                v-if="form.area_of_study && study_area.label.toLowerCase().indexOf(form.area_of_study.toLowerCase()) > -1">
                <a @click.prevent="() => selectAreaStudy(study_area.label)" class="study-area-option">{{ study_area.label }}</a>
              </li>
            </ul>
          </v-form-item>        

          <v-form-item label="Test Score" :label-col="{span: 6}" :wrapper-col="{span: 14}" prop="ielts">
            <v-input size="large" v-model="form.ielts" placeholder="Min. Test Score required"></v-input>
          </v-form-item>

          <v-form-item label="Tution Fee" :label-col="{span: 6}" :wrapper-col="{span: 14}" prop="tution_fee_val">
            <v-input size="large" v-model="form.tution_fee_val" placeholder="Tution Fee"></v-input>
          </v-form-item>
        </div>
      </div>

      <div class="intake-wrap">
        <v-form-item label="September Intake" prop="september">
          <v-radio-group size="small" type="button" v-model="form.september"
            :data="[{value: 1, text: 'Yes'},{value: 0, text: 'No'}]">
          </v-radio-group>
        </v-form-item>

        <div>
          <v-form-item label="January Intake" prop="january">
            <v-radio-group size="small" type="button" v-model="form.january"
              :data="[{value: 1, text: 'Yes'},{value: 0, text: 'No'}]">
            </v-radio-group>
          </v-form-item>
        </div>

        <div>
          <v-form-item label="May Intake" prop="may">
            <v-radio-group size="small" type="button" v-model="form.may"
              :data="[{value: 1, text: 'Yes'},{value: 0, text: 'No'}]">
            </v-radio-group>
          </v-form-item>
        </div>
      </div>

      <v-form-item :wrapper-col="{offset:6, span: 14 }" class="button-wrap">
        <v-button type="primary" style="margin-right:10px" @click.prevent="submitForm('formRef')">Submit</v-button>
        <v-button type="ghost" @click.prevent="resetForm('formRef')">Reset</v-button>
      </v-form-item>
    </v-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'EditProgram',
  computed: {
    ...mapGetters([
      'schools',
      'lov',
      'program'
    ])
  },
  created () {
    this.$store.dispatch('getProgram', this.$route.params.programId)
    document.addEventListener('click', this.documentClick)
  },
  watch: {
    program: {
      handler (val) {
        if (val) {
          this.form = val
          this.editedProgram = {...val}
        }
      }
    },
    schools: {
      handler (val) {
        if (!val) {
          this.$store.dispatch('getSchools')
        }
      },
      immediate: true
    },
    lov: {
      handler (val) {
        if (!val) {
          this.$store.dispatch('getLov')
        } else {
          for (let key in val.study_areas) {
            this.optionsStudyAreas.push({value: key, label: key})
            this.studyOptionsText += key.toLowerCase()
          }
        }
      },
      immediate: true
    }
  },
  data () {
    return {
      editedProgram: null,
      studyOptionsDisplay: false,
      studyOptionsText: '',
      optionsStudyLevels: [{
        label: 'Grade-10',
        value: 'G10'
      }, {
        label: 'Grade-12',
        value: 'G12'
      }, {
        label: '1-Year Post-Secondary Certificate',
        value: 'D1'
      }, {
        label: '2-Year Undergraduate Diploma',
        value: 'D2'
      }, {
        label: '3-Year Undergraduate Advanced Diploma',
        value: 'D3'
      }, {
        label: '4-Year Bachelor\'s Degree',
        value: 'B4'
      }, {
        label: 'Postgraduate Certificate / Master\'s Degree',
        value: 'PG'
      }],
      optionsStudyAreas: [],
      optionsSpecialization: [],
      form: {
        name: null,
        school_name: null,
        school: null,
        level_of_study: null,
        area_of_study: null,
        tution_fee_val: null,
        application_fee_val: null,
        duration: null,
        ielts: null,
        september: null,
        january: null,
        may: null,
        display_status: 1
      },
      rules: {
        name: [{
          required: true,
          message: '* Required'
        }],
        school_name: [{
          required: true,
          message: '* Required'
        }],
        level_of_study: [{
          required: true,
          message: '* Required'
        }],
        area_of_study: [{
          required: true,
          message: '* Required'
        }],
        tution_fee_val: [{
          required: true,
          message: '* Required'
        }],
        application_fee_val: [{
          required: true,
          message: '* Required'
        }],
        duration: [{
          required: true,
          message: '* Required'
        }],
        ielts: [{
          required: true,
          message: '* Required'
        }],
        september: [{
          required: true,
          message: '* Required'
        }],
        january: [{
          required: true,
          message: '* Required'
        }],
        may: [{
          required: true,
          message: '* Required'
        }]
      }
    }
  },
  methods: {
    selectChange (key, val) {
      this.form[key] = val
    },
    selectSchool (value) {
      const selected = this.schools.find(x => {
        let key = x.campus ? `${x.name}, ${x.campus}` : x.name
        return key === value
      })
      this.form.school_name = selected.campus ? `${selected.name}, ${selected.campus}` : selected.name
      this.form.school = selected
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.form.tution_fee = `CA $${parseFloat(Math.round(this.form.tution_fee_val * 100) / 100).toFixed(2)}`
          this.form.application_fee = `CA $${parseFloat(Math.round(this.form.application_fee_val * 100) / 100).toFixed(2)}`
          this.$store.dispatch('updateProgram', {id: this.editedProgram.id, payload: this.form})
        } else {
          return false
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    selectAreaStudy (study_area) {
      this.form.area_of_study = study_area
      this.studyOptionsDisplay = false
    },
    documentClick (ev) {
      if (ev.target.className === 'study-area-option') {
        this.studyOptionsDisplay = true
      } else {
        this.studyOptionsDisplay = false
      }
    }
  }
}
</script>

<style scoped>
h2 {
  margin-bottom: 8px;
}
.description {
  margin-bottom: 34px;
}
.form-elem-wrap {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.button-wrap {
  margin-top: 30px;
  display: flex;
  justify-content: center;
  flex-direction: row;
}
.intake-wrap {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding-left: 40px;
}
.intake-wrap > div {
  margin-right: 40px;
}
.intake-wrap .ant-row.ant-form-item {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/views/Admin/Programs/EditProgram.vue